import { adoptGuestFromUrl } from "../guest";

export function authHeader() {
  const access_token = localStorage.getItem("zippyToken");
  const headers = {
    "Content-Type": "application/json",
    "x-guest-token": adoptGuestFromUrl(),
  };
  if (access_token) {
    headers.Authorization = "Bearer " + access_token;
  }
  return headers;
}
